import { fromJS } from 'immutable';
import reducer from 'src/utils/redux/reducer';
import {
  BUILDER_ADD_ROW, BUILDER_ADD_SUB, BUILDER_DELETE_ROW,
  BUILDER_CHANGE_VALUE, BUILDER_SET_APPLY, BUILDER_TOGGLE_APPLY,
  BUILDER_SET,
} from './types';
import { filter } from 'src/types';

const getNewRow = () => fromJS({
  logic: filter.LOGIC.AND,
  field: null,
  is: filter.IS.IS,
  type: filter.TYPE.CONTAINS,
  clause: '',
});

const getNewSub = () => fromJS({
  logic: filter.LOGIC.AND,
  sub: [getNewRow()],
});

// --- initialState ---

export const initialState = {
  query: fromJS([
    getNewRow(0),
  ]),
  applied: false,
};

// --- handlers ---

const handleSetInitial = () => initialState;

const handleBuilderAddRow = (state, action) => {
  const node = (action.path ? state.query.getIn(action.path) : state.query).push(getNewRow());
  const query = action.path ? state.query.setIn(action.path, node) : node;

  return {...state, query, applied: false};
};

const handleBuilderAddSub = (state, action) => {
  const node = (action.path ? state.query.getIn(action.path) : state.query).push(getNewSub());
  const query = action.path ? state.query.setIn(action.path, node) : node;

  return {...state, query, applied: false};
};

const handleBuilderDeleteRow = (state, action) => {
  let query = state.query.deleteIn([...action.id]);

  // ToDo fix sub query clean up
  const clearNode = (path) => {
    const nodes = path.slice();
    let index = nodes.pop();

    while (nodes.length > 0) {
      if (index === 'sub' && query.getIn(nodes).size < 1) {
        query = query.deleteIn(nodes);
      }
      nodes.pop();
    }
  };

  clearNode(action.id);

  if (query.size < 1) {
    query = initialState.query;
  }

  return { ...state, query, applied: false };
};

const handleBuilderChangeValue = (state, action) => {
  const query = state.query.setIn([...action.id, action.field], action.value);

  return { ...state, query, applied: false };
};

const handleBuilderSetApply = (state, action) => ({
  ...state,
  applied: action.applied,
});

const handleBuilderToggleApply = (state, action) => ({
  ...state,
  applied: !state.applied,
});

const handleBuilderSet = (state, action) => ({
  ...state,
  query: fromJS(action.payload),
  applied: action.applied,
});

const handlers = {
  'SET_INITIAL': handleSetInitial,
  [BUILDER_ADD_ROW]: handleBuilderAddRow,
  [BUILDER_ADD_SUB]: handleBuilderAddSub,
  [BUILDER_DELETE_ROW]: handleBuilderDeleteRow,
  [BUILDER_CHANGE_VALUE]: handleBuilderChangeValue,
  [BUILDER_SET_APPLY]: handleBuilderSetApply,
  [BUILDER_TOGGLE_APPLY]: handleBuilderToggleApply,
  [BUILDER_SET]: handleBuilderSet,
};

// --- reducerFactory ---

export default flows => reducer({ initialState, handlers, flows });